/** 图片上传入口使用的裁剪比例与建议输出尺寸。 */
export interface ImageUploadSpec {
    /** 裁剪区域宽高比，宽除以高。 */
    aspectRatio: number;
    /** 建议输出宽度，单位 px。 */
    width: number;
    /** 建议输出高度，单位 px。 */
    height: number;
}

/** 全站图片上传入口规格。 */
export const IMAGE_UPLOAD_SPECS = {
    /** 菜单、菜品及常规横向营销图片。 */
    landscape: { aspectRatio: 16 / 10, width: 1280, height: 800 },
    /** 餐厅 Logo、集团 Logo、员工头像及联系二维码。 */
    square: { aspectRatio: 1, width: 512, height: 512 },
    /** MOP 首页轮播图。 */
    mopCarousel: { aspectRatio: 9 / 16, width: 1080, height: 1920 },
    /** QOP 自定义模板。 */
    qopTemplate: { aspectRatio: 1240 / 1748, width: 1240, height: 1748 },
} satisfies Record<string, ImageUploadSpec>;

/**
 * 格式化图片编辑器建议尺寸。
 * @param spec - 图片上传规格
 * @returns 形如「1280×800」的尺寸文案
 */
export function formatImageUploadSuggestion(spec: ImageUploadSpec): string {
    return `${spec.width}×${spec.height}`;
}
